export default __webpack_public_path__ + "static/media/folder.3993affe.svg";